<div class="container-layout">
  <!-- Todo el bloque de la barra lateral, incluyendo el header móvil y la navegación,
       solo debe mostrarse si el usuario está autenticado. -->
  @if (authService.isAuthenticated()) {
    <div class="sidebar">
      <app-mobile-header
        [logoSrc]="theme?.images?.mobileLogo?.path ?? '/assets/icons/Frame.svg'"
        [fallbackLogoPath]="theme?.images?.mobileLogo?.fallback ?? '/assets/icons/Frame.svg'"
        [logoWidth]="theme?.images?.mobileLogo?.width"
        [logoHeight]="theme?.images?.mobileLogo?.height"
      />

      @if (nav.isOpen()) {
        <div class="backdrop" (click)="nav.close()"></div>
      }
      <app-nav-bar></app-nav-bar>
    </div>
  }

  <div class="main-content">
    <router-outlet ></router-outlet>
  </div>
</div>

@if (loadingService.isLoading()) {
  <app-modal-carga-component
    title="Cargando..."
    subTitle="Por favor espera">
  </app-modal-carga-component>
}
